import { FC, useState } from "react";
import Slider from "react-slick";
import { arrow, img } from "../../../assets/icon";
import SVG from "react-inlinesvg";
import {
  ButtonBox,
  ButtonNext,
  ButtonPrev,
  ContainerItem,
  Image,
  Text,
  ThumbImage,
  Title,
  TotalBox,
  TotalSum,
  TotalText,
  Video,
  Wraper,
} from "./ResultItemMany.styled";

import "slick-carousel/slick/slick.css";

import { useMobile } from "../../../hooks/useMobile";
import { getStyleFromTextConfig } from "../../../utils/style";
import { Button } from "../../Button/Button";
import { ResultItemOne } from "../ResultItemOne/ResultItemOne";
import { useUnits } from "../../../hooks/useUnits";


type Props = {
  results: any[];
  currency: any;
  //button_style?: number;
  addition_page_display?: number;
  after_contacts: boolean;
  additions: any[];
  onNext?: (linkTo: string) => void;
  lockBonus: boolean;
};

export const ResultItemMany: FC<Props> = ({
  results,
  currency,
  after_contacts,
  //button_style,
  addition_page_display,
  additions,
  onNext,
  lockBonus
}) => {
  const [selected, setSelected] = useState<any>(null);

  const isMobile = useMobile();
  const units = useUnits();

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: isMobile ? 1 : 3,
    initialSlide: 0,
    cssEase: "linear",
    //adaptiveHeight: true,
    nextArrow: (
      <ButtonNext>
        <SVG src={arrow} />
      </ButtonNext>
    ),
    prevArrow: (
      <ButtonPrev>
        <SVG src={arrow} />
      </ButtonPrev>
    ),
  };
  if (selected)
    return (
      <ResultItemOne
        result={selected}
        currency={currency}
        addition_page_display={addition_page_display}
        additions={additions}
        after_contacts={after_contacts ?? false}
        showBackButton={true}
        onNext={() => onNext && onNext(selected?.button_link)}
        onBack={() => setSelected(null)}
        lockBonus={lockBonus}
      />
    );

  return (
    <Wraper>
      <Slider {...settings}>
        {results.map((item) => {
          const {
            id,
            title,
            description,
            description_config,
            print_total,
            button,
            add_image,
            image,
            video_link,
            button_text,
            //calculation_type,
            calculation_config,
          } = item;

          const calculation_type = item?.calculation_type ?? 1;

          return (
            <ContainerItem key={id}>
              <ThumbImage>
                {add_image ? (
                  <Image src={image ?? img} title="result image" />
                ) : (
                  <Video src={video_link} controls />
                )}
                {print_total && (
                  <TotalBox>
                    <TotalText>
                      {!calculation_config.unit &&
                        (units.find(({ id }) => id === calculation_config.unit)?.title ?? units[0]?.title)}
                    </TotalText>
                    <TotalSum>
                      {!calculation_config.unit
                        ? `${currency?.title} `
                        : `${units[calculation_config.unit].title} `}

                      {calculation_type === 1 &&
                        (calculation_config.useSingleValue
                          ? `${calculation_config.resultValue ?? 0}`
                          : `${calculation_config.resultValueFrom ?? 0} - ${calculation_config.resultValueTo ?? 0}`)}
                      {calculation_type === 2 && (item.formula_result || 0)}
                      {calculation_type === 3 && (item.sum_points || 0)}
                    </TotalSum>
                  </TotalBox>
                )}
              </ThumbImage>
              <Title>{title}</Title>
              <Text style={getStyleFromTextConfig(description_config)}>
                {description}
              </Text>
              {(button || !after_contacts) && (
                <ButtonBox>
                  <Button
                    //type={button_style}
                    isHideArrow={false}
                    isShowBack={false}
                    title={button_text}
                    onNext={() => {
                      setSelected(item);
                    }}
                  />
                </ButtonBox>
              )}
            </ContainerItem>
          );
        })}
      </Slider>
    </Wraper>
  );
};
